import type { Locale } from '@fastnorth/i18next';

const formatProgressPercent = (value: number, locale: Locale): string => {
  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
  }).format(value);

  return `${formatted}%`;
};

export default formatProgressPercent;
